import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=70c2460b&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=70c2460b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c2460b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70c2460b')) {
      api.createRecord('70c2460b', component.options)
    } else {
      api.reload('70c2460b', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=70c2460b&scoped=true&", function () {
      api.rerender('70c2460b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cbEzrgD61qU5/JS/comp/GuestBox.vue"
export default component.exports